import axios from 'axios';
import { getDemoResponse, isDemoMutation } from './demoResponses';
import { isAppOnlyPayload, redirectToAppOnly } from './appOnly';
import i18n from './i18n';

axios.defaults.baseURL = 'http://localhost:3000/';

axios.interceptors.request.use((config) => {
    if (isDemoMutation(config)) {
        window.dispatchEvent(new Event('timetab:demo-write-blocked'));
        const message = i18n.t('demo_mode.read_only');
        const error = new Error(message);
        error.code = 'ERR_DEMO_READ_ONLY';
        error.config = config;
        error.response = {
            data: {
                error: 'demo_read_only',
                message,
            },
            status: 403,
            statusText: 'Forbidden',
            headers: {},
            config,
        };
        return Promise.reject(error);
    }

    const locationId = localStorage.getItem('selected_location_id');
    if (locationId) {
        config.headers = config.headers || {};
        config.headers['X-TimeTab-Location-ID'] = locationId;
    }

    const demoResponse = getDemoResponse(config);
    if (demoResponse) {
        config.adapter = () => Promise.resolve(demoResponse);
    }
    return config;
});

axios.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;
        if (error.response?.status === 403 && isAppOnlyPayload(error.response?.data)) {
            redirectToAppOnly();
            return Promise.reject(error);
        }
        if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;
            window.dispatchEvent(new Event('refreshToken')); // Trigger token refresh
            return axios(originalRequest); // Retry request after token refresh
        }
        return Promise.reject(error);
    }
);
